<template>
  <div>
    <el-table :data="wifiData" border size="mini" :empty-text="emptyText" style="margin-top:25px"
      :header-cell-style="{ background: '#e4f1ff' }">
      <el-table-column :label="$t('lang.TableComponent.serialNumber')" min-width="50px">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.interfaceName')" prop="alias">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.row.ifname }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.interfaceStatus')" prop="vendor">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">
            <span class="badge-status-badge-status"></span>
            <span class="fontStyle">{{ $t('lang.wireless.running') }}</span>
          </div>
          <div v-if="scope.row.status == 0">
            <span class="badge-status-badge-error"></span>
            <span class="fontStyle" v-if="scope.row.status != -1">{{ $t('lang.wireless.stop') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.ip')" prop="ipaddr" min-width="100px">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.row.ipaddr }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.subnetMask')" prop="netmask" min-width="100px">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.row.netmask }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.gateway')" prop="gateway" min-width="100px">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.row.gateway }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.protocol')" prop="proto">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.row.proto }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.DNSServer')" prop="dns" min-width="140px">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.row.dns }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.hops')" prop="metric">
        <template slot-scope="scope">
          <span class="fontStyle">{{ scope.row.metric }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.connectTime')" prop="connTime" min-width="120px">
        <template slot-scope="scope">
          <span class="fontStyle">{{ getSecond(scope.row.connTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.uplink')" prop="rx_bytes">
        <template slot-scope="scope">
          <span class="fontStyle">{{ getTraffic(scope.row.tx_bytes) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.wireless.downlink')" prop="tx_bytes" min-width="90px">
        <template slot-scope="scope">
          <span class="fontStyle">{{ getTraffic(scope.row.rx_bytes) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { wifiInfo } from '@/api/particulars'
import { listConfig } from "@/api/configurationlist";
import { getOnlineTime, SecondToDate } from '@/utils/Date.js'
import { cloneDeep } from 'lodash'
export default {
  props: ['did', 'dsn'],
  data() {
    return {
      wifiData: [],
      emptyText: this.$t('lang.TableComponent.loading'),
      STA: false,
      timer: null,
      current: ''
    }
  },
  mounted() {
    // this.getConfig()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    getConfig() {
      this.wifiData = []
      this.emptyText = this.$t('lang.TableComponent.loading')
      // 查看wifi是否有sta模式，有才发起请求
      listConfig(this.dsn, this.did, [
        {
          section: "wifi-iface",
          config: "wireless",
          options: [
            { option: "mode" },
          ]
        }
      ]).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data.mess[0].s_objects;
          data.map((item, index) => {
            if (item.options.mode == 'sta') {
              this.STA = true
            }
          })
          if (this.STA) {
            this.getWifi()
            this.timer = setInterval(() => {
              this.getWifi()
            }, 10000)
          } else {
            this.emptyText = this.$t('lang.TableComponent.empty')
          }
        }
      }).catch(err => {
        this.emptyText = this.$t('lang.TableComponent.loadingFail')
        // this.$message({
        //   message: "请求超时，请重试",
        //   type: "warning"
        // })
      })
    },
    async getWifi() {
      let infoData = []
      await wifiInfo(this.did, this.dsn).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data.mess.wwan
          if (data) {
            infoData.push(data)
          } else {
            this.emptyText = this.$t('lang.TableComponent.empty')
          }
        }
      })
      this.wifiData = cloneDeep(infoData)
    },
    //计算毫秒数
    getSecond(msd) {
      return SecondToDate(msd)
    },
    // 计算流量
    getTraffic(byte) {
      return getOnlineTime(byte)
    },
    clearTimer() {
      clearInterval(this.timer)
    }
  },
  watch: {
    dsn: {
      immediate: true,
      handler() {
        this.getConfig()
      }
    }
  }
}
</script>
<style scoped>
.badge-status-badge-status {
  width: 10px;
  height: 10px;
  background-color: #67c23a;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}

.badge-status-badge-error {
  width: 10px;
  height: 10px;
  background-color: #f56c6c;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}

.fontStyle {
  padding-left: 10px;
  font-size: 0.25rem;
}
</style>